import { FC } from 'react';

import type { IConsultation } from '../../store/types';
import { consultationMeetFormatLabel } from '../../utils/consultation';

type Props = {
  consultation: Pick<IConsultation, 'consultation_type'>;
};

/** Иконка формата встречи в списке журнала: тултип онлайн / очная (без свойства — онлайн). */
export const JournalConsultationFormatIcon: FC<Props> = ({ consultation }) => {
  const label = consultationMeetFormatLabel(consultation);

  return (
    <span className="relative inline-flex h-5 w-5 shrink-0 items-center justify-center hover:[&>.journal-consult-format-tip]:opacity-100">
      <svg className="h-5 w-5 text-[#C00000]" viewBox="0 0 20 20" fill="none" aria-hidden>
        <path
          d="M10 10a3.333 3.333 0 100-6.667 3.333 3.333 0 000 6.667zM4.167 15v-1.667a3.333 3.333 0 013.333-3.333h5a3.333 3.333 0 013.334 3.333V15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
      <span
        className="journal-consult-format-tip pointer-events-none absolute left-1/2 top-full z-20 mt-1 flex min-h-[30px] min-w-[109px] -translate-x-1/2 flex-col items-center opacity-0 transition-opacity duration-150"
        role="tooltip"
      >
        <span
          className="h-0 w-0 border-x-[6px] border-b-[7px] border-x-transparent border-b-[#2C3038]"
          aria-hidden
        />
        <span className="-mt-px rounded-lg bg-[#2C3038] px-2.5 py-1.5 text-center text-xs font-manrope font-medium leading-tight text-white shadow-md">
          {label}
        </span>
      </span>
    </span>
  );
};
